import React from 'react';
import PriceTable from './PriceTable';
import { pricingData } from './PricesData';
 
function PrestaSection() {
    return (
        <div className="eco">
            <PriceTable categoryData={pricingData.coupesEco} categoryName="eco"/>
            <PriceTable categoryData={pricingData.coupesPremium} categoryName="premium" />
            <PriceTable categoryData={pricingData.coupesTechniques} categoryName="techniques" />
        </div>
    )
}

export default PrestaSection;
